/**
 * Automation Canvas Mask Component
 *
 * Follows Note-Edgeless-Mask pattern with ResizeObserver for correct positioning.
 */

import { SignalWatcher, WithDisposable } from '@blocksuite/global/lit';
import { type EditorHost, ShadowlessElement } from '@blocksuite/std';
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';

import type { AutomationBlockModel } from '../../schemas/index.js';
export class AutomationCanvasMask extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  protected override firstUpdated() {
    // Note: Automation blocks have fixed height, no dynamic resizing needed
    // The mask is just an overlay for interactions, not a content container
  }

  override render() {
    const borderRadius = this.model.props.edgeless.style.borderRadius;

    return html`
      <div
        class="affine-automation-mask"
        style=${styleMap({
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: '1',
          pointerEvents: this.editing || this.disableMask ? 'none' : 'auto',
          borderRadius: `${borderRadius * this.zoom}px`,
        })}
      ></div>
    `;
  }

  @property({ attribute: false })
  accessor disableMask: boolean = false;

  @property({ attribute: false })
  accessor editing: boolean = false;

  @property({ attribute: false })
  accessor host!: EditorHost;

  @property({ attribute: false })
  accessor model!: AutomationBlockModel;

  @property({ attribute: false })
  accessor zoom: number = 1;
}

declare global {
  interface HTMLElementTagNameMap {
    'automation-canvas-mask': AutomationCanvasMask;
  }
}
